import { GlassCard } from './GlassCard';

export const BentoGrid = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => {
    return (
        <div
            className={`grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[220px] max-w-7xl mx-auto px-4 ${className}`}
        >
            {children}
        </div>
    );
};

export const BentoGridItem = ({
    className,
    title,
    description,
    header,
    icon,
}: {
    className?: string;
    title?: string | React.ReactNode;
    description?: string | React.ReactNode;
    header?: React.ReactNode;
    icon?: React.ReactNode;
}) => {
    return (
        <GlassCard
            className={`${className} flex flex-col justify-between group hover:border-emerald-500/50 transition-all duration-700 overflow-hidden relative border-white/5 bg-black/40 p-6`}
        >
            <div className="absolute inset-0 bg-gradient-to-br from-transparent via-emerald-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

            <div className="relative z-10 h-full flex flex-col">
                <div className="mb-4">
                    {header}
                </div>
                <div className="mt-auto">
                    <div className="mb-2 transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 origin-left inline-block">
                        {icon}
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2 group-hover:text-emerald-400 transition-colors tracking-tight">
                        {title}
                    </h3>
                    <p className="text-xs text-gray-400 leading-relaxed font-mono opacity-80 group-hover:opacity-100 transition-opacity line-clamp-2">
                        {description}
                    </p>
                </div>
            </div>

            <div className="relative z-10 flex justify-end mt-2">
                <span className="text-[8px] font-mono text-emerald-500/30 tracking-[0.3em] uppercase">
                    SYSTEM_LOG
                </span>
            </div>
        </GlassCard>
    );
};
